export default __webpack_public_path__ + "static/media/iconVerde.28892acd.png";